import { RosTemplate, RosTemplateControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const useNewTemplateCreate = () =>
  useMutationWithLoading(
    async (param: { rosTemplate: RosTemplate; xTENANTID?: string }) =>
      new RosTemplateControllerApi(getConfigObject()).createRosTemplate(
        param?.rosTemplate,
        param?.xTENANTID
      )
  );
